/**
 * Kulisse für die Arbeits- und Generierungsfolien: Code, der im Hintergrund
 * durchläuft.
 *
 * Lokale Kopie von offsites/ar/slides/_code-kulisse.tsx.
 *
 * Sehr zurückhaltend gehalten. Auf der Leinwand steht die Zeit oder der
 * Fortschritt im Vordergrund; die Kulisse soll zeigen, dass gearbeitet wird,
 * und darf nicht mit dem konkurrieren, was die Gruppe lesen soll.
 *
 * Reine CSS-Animation, kein Canvas und keine Bibliothek: Sie läuft 8 bis 25
 * Minuten am Stück auf einem Laptop, der gleichzeitig einen Beamer versorgt.
 * `prefers-reduced-motion` schaltet sie still.
 */

/** Zeilen ohne Aussage — es geht um Textur, nicht um Inhalt. Aus dem
 *  Arbeitsalltag von Vertrieb, Netz und Montage, damit die Kulisse zum
 *  Publikum passt. */
const ZEILEN = [
  "async function erzeugePrototyp(anforderung) {",
  "  const felder = await lese(anforderung.thema);",
  "  if (!felder.length) return leer();",
  "  return render(felder, { format: 'html' });",
  "}",
  "",
  "const meldung = { schaden, standort, foto };",
  "await validiere(meldung).catch(zeigeFehler);",
  "",
  "export function Arbeitsbericht({ diktat }) {",
  "  const saetze = gliedere(diktat);",
  "  return <Bericht abschnitte={saetze} />;",
  "}",
  "",
  "SELECT anlage, arbeitsanweisung FROM doku",
  "  WHERE stichwort = ? ORDER BY aktualisiert DESC;",
  "",
  "def lese_zaehlerstand(bild):",
  "    text = ocr(bild, sprache='deu')",
  "    return werte_aus(text)",
  "",
  "for (const feld of pflichtfelder) {",
  "  if (!eingabe[feld]) fehlt.push(feld);",
  "}",
  "",
  "commit -m 'Prototyp aus deiner Anforderung'",
];

export function CodeKulisse({
  /** Wie viele Spalten durchlaufen. Zwei reichen für die Textur. */
  spalten = 2,
}: {
  spalten?: number;
}) {
  return (
    <div className="code-kulisse" aria-hidden="true">
      {Array.from({ length: spalten }, (_, i) => (
        <div key={i} className={`code-spalte code-spalte-${i + 1}`}>
          {/* Zweimal dieselbe Liste: so kann die Animation nahtlos umlaufen,
              ohne dass eine Lücke durch das Bild wandert. */}
          {[0, 1].map((durchlauf) => (
            <div key={durchlauf} className="code-block">
              {ZEILEN.map((z, n) => (
                <div key={n} className="code-zeile">
                  {z || " "}
                </div>
              ))}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
